import SurveyBrowser from './Browser';

export default function SurveyList() {
    return <SurveyBrowser />;
}
